'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Popover = require('@material-ui/core/Popover');
var ColorPickerButton = require('./ColorPickerButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);

/** Popover menu for selecting a color. */

function ColorPickerMenu(_ref) {
  var {
    anchor,
    close,
    onChange,
    value,
    colors
  } = _ref;
  return /*#__PURE__*/React__default['default'].createElement(Popover__default['default'], {
    sx: {
      marginTop: 0.5
    },
    open: !!anchor,
    onClose: close,
    anchorEl: anchor,
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'left',
      vertical: 'top'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      maxWidth: 32 * 6,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap'
    }
  }, colors.map(color => /*#__PURE__*/React__default['default'].createElement(ColorPickerButton.ColorPickerButton, {
    key: color,
    color: color,
    onClick: () => onChange(color),
    checked: value === color
  }))));
}
ColorPickerMenu.propTypes = {
  /** The current color value of the picker. */
  value: index.string,
  anchor: index.any,
  close: index.func,
  onChange: index.func.isRequired
};

exports.ColorPickerMenu = ColorPickerMenu;
